class Richtext
    constructor: (el) ->
        @.$el = el

        @.preParsed = @.$el.classList.contains 'richtext--pre-parsed'

        if !@.preParsed
            @.ParseContent()
        @.$el.classList.add 'richtext--bound'
        return

    ParseContent: ->
        # headlines
        headlineTagElements = []
        for level in [1..6]
            headlineTagElements[level - 1] = @.$el.querySelectorAll "h#{ level }"
        level = 1
        headlineTagElements.forEach (headlineElements) ->
            headlineElements.forEach (headlineElement) ->
                existingHeadlineSizeClasses = headlineElement.classList.value.split(' ').filter (elClass) ->
                    elClass.toLowerCase().includes 'headline--'
                if !headlineElement.classList.contains '.headline'
                    size = headlineElement.dataset?.size ? existingHeadlineSizeClasses[0]?.substring(10,11) ? level
                    headlineComponent = window.CreateHeadline {
                        level: level
                        size: size,
                        text: headlineElement.innerHTML
                    }
                    headlineElement.replaceWith headlineComponent
                return
            level++
            return
        # markdown links
        @.$el.innerHTML = @.$el.innerHTML.replace /\[([^\]]+)\]\(([^\)]+)\)/ig, '<a href="$2" target="_blank">$1</a>'
        return

BindRichtexts = ->
    document.querySelectorAll '.richtext:not(.richtext--bound)'
        .forEach (el) ->
            new Richtext el
            return
    return

window.addEventListener 'bind-components', BindRichtexts

class RichtextCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bindLater = options?.bindLater ? false
        @.maxWidth = options?.maxWidth ? false
        @.preParsed = options?.preParsed ? false
        @.tag = options?.tag ? 'div'
        @.textAlign = options?.textAlign ? false
        @.textContent = options?.textContent ? '<p>Text</p>'

        @.CreateElement()
        if !@.bindLater
            new Richtext @.$el
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.classList.add 'richtext'
        if @.maxWidth
            @.$el.classList.add 'richtext--max-width'
        if @.preParsed
            @.$el.classList.add 'richtext--pre-parsed'
        if @.textAlign
            @.$el.classList.add "richtext--align-#{ @.textAlign }"
        @.$el.innerHTML = @.textContent
        return

window.CreateRichtext = (options) ->
    return new RichtextCreate options